<div class="modal-header">
    <h4 class="modal-title">Aconto fakturering</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <app-interim-invoicing-options
        (acontoDate)="onAcontoDate($event)"
        (acontoType)="onAcontoType($event)"
        (acontoBulk)="acontoBulk($event)"
        [acontoClients]="acontoClients$ | async"
    ></app-interim-invoicing-options>
    <div class="table__viewport">
        <app-interim-invoicing-list
            [acontoClients]="acontoClients$ | async"
        ></app-interim-invoicing-list>
    </div>
</div>
